/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect, useState} from "react";
import {useTypedSelector} from "helpers/reducers";
import {useTranslation} from "react-i18next";
import CardComponent from "pages/Front/Booking/components/CardComponent";
import Loader from "components/Loader";
import {Payment} from "types/entities/Payment";
import {AtSymbolIcon, PhoneIcon} from "@heroicons/react/24/outline";

const BookingPaidCustomer = () => {
    const hall = useTypedSelector(state => state.hallState.hall);
    const payment = useTypedSelector(state => state.bookingState.bookingProcess.payment);
    const {t} = useTranslation();
    const [result, setResult] = useState<Payment | null>(null);

    useEffect(() => {
        if (payment) {
            setResult(payment);
        }
    }, [payment]);
    if (!hall || !result) {
        return <Loader />;
    }
    return (
        <div className={"BookingPaidCustomer flex-grow"}>
            <CardComponent className={"w-full text-sm sm:text-lg"}>
                {result.customer && (
                    <div className={"flex flex-col space-y-2 mb-2 pb-4 items-start"}>
                        <h4 className={"text-sm sm:text-lg text-center font-black text-primary-800"}>{t("Contact information that you've entered")}</h4>
                        <span>
                            {t("Customer")}:{" "}
                            <b>
                                {result.customer.first_name} {result.customer.last_name}
                            </b>
                        </span>
                        <span>
                            {t("Email")}: <b>{result.customer.email}</b>
                        </span>
                        <span>
                            {t("Phone")}: <b>{result.customer.phone}</b>
                        </span>
                    </div>
                )}
                <hr />
                <div>{t("If you have any questions or problems, please contact our customer service directly")}.</div>
                {hall.contact && (
                    <div className={"flex flex-row justify-start items-start"}>
                        <PhoneIcon className={"w-4 h-4 mr-2"} />
                        <a href={`tel:${hall.contact}`}>
                            <b>{hall.contact}</b>
                        </a>
                    </div>
                )}
                {hall.email && (
                    <div className={"flex flex-row justify-start items-start"}>
                        <AtSymbolIcon className={"w-4 h-4 mr-2"} />{" "}
                        <a href={`mailto:${hall.email}`}>
                            <b>{hall.email}</b>
                        </a>
                    </div>
                )}
            </CardComponent>
        </div>
    );
};

export default BookingPaidCustomer;
